const DateFormatting = {
  locale: {
    'en-US': {
      month_names: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      month_names_short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    },
    'fr-FR': {
      month_names: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
      month_names_short: ['janv', 'fevr', 'mars', 'avril', 'mai', 'juin', 'juil', 'aout', 'sept', 'oct', 'nov', 'Dec']
    },
    'es-ES': {
      month_names: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
      month_names_short: ['enero', 'feb', 'marzo', 'abr', 'mayo', 'jun', 'jul', 'agosto', 'set', 'oct', 'nov', 'dic']
    },
    'de-DE': {
      month_names: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
      month_names_short: ['Jan', 'Feb', 'März', 'Apr', 'Mai', 'Juni', 'Juli', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
    }
  },
  getMonthName(date, lang) {
    lang = lang && lang in this.locale ? lang : 'en-US';
    return this.locale[lang].month_names[date.getMonth()];
  },
  getMonthNameShort(date, lang) {
    lang = lang && lang in this.locale ? lang : 'en-US';
    return this.locale[lang].month_names_short[date.getMonth()];
  }
};

export { DateFormatting };
